import Api from './Api';

class LogicBaseCommentApi extends Api {
  url = 'logicbasecomments';
}

const singleton = new LogicBaseCommentApi();
export default singleton;
